import Pickr from "@simonwep/pickr";
const configs = (
  el,
  defaultColor,
  disabled = false,
  position = "bottom-start",
) => ({
  el: el,
  container: "body",
  theme: "nano",

  appClass: "teste-class",

  useAsButton: false,

  padding: 8,

  inline: false,
  autoReposition: true,

  disabled,
  lockOpacity: false,

  outputPrecision: 0,

  comparison: true,

  default: defaultColor || "#FFFFFF",

  swatches: null,

  defaultRepresentation: "HEX",

  showAlways: false,

  position,

  components: {
    palette: true,
    preview: true,
    opacity: false,
    hue: true,
    interaction: {
      input: true,
      save: true,
    },
  },
});

function getPickerPosition(container) {
  const rect = container.getBoundingClientRect();
  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;
  return spaceAbove > spaceBelow ? "top-start" : "bottom-start";
}

// mapeia o parametro 'position' (top/left/right) recebido pelo componente para
// o formato aceito pelo Pickr; sem valor, mantem o auto-detect por espaco disponivel
const positionMap = {
  top: "top-start",
  left: "left-start",
  right: "right-start",
};

export function createColorPicker(
  classOfContainer,
  setStateFunc,
  defaultColor,
  disabled,
  position,
) {
  const pickerContainer = document.querySelector(`.${classOfContainer}`);
  const pickerElement = document.createElement("div");
  pickerContainer.insertBefore(pickerElement, pickerContainer.firstChild);

  const resolvedPosition =
    positionMap[position] || getPickerPosition(pickerContainer);

  const pickr = new Pickr(
    configs(pickerElement, defaultColor, disabled, resolvedPosition),
  );

  // a posicao e definida na criacao do pickr, acima. o Pickr 1.9.1 nao expoe
  // setOptions, entao nao ha como reposicionar no evento show: tentar fazer isso
  // lancava excecao a cada abertura do seletor
  pickr.on("save", (color) => {
    setStateFunc(color.toHEXA().toString(3));
    pickr.hide();
  });
}
